import { createFileRoute, Outlet, useRouter } from '@tanstack/react-router';
import { Loader } from 'lucide-react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '@/lib/firebase/client';

export const Route = createFileRoute('/experimental/_experimentalLayout')({
  component: ExperimentalLayout,
});

function ExperimentalLayout() {
  const [user, loading] = useAuthState(auth);
  const router = useRouter();

  if (loading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Loader color="#385af5" />
      </div>
    );
  }

  if (!user) {
    router.navigate({
      to: '/login',
      search: { destination: '/experimental/sar' },
    });
  }

  return <Outlet />;
}
